export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const REGISTER_START = 'REGISTER_START';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';

export const CHECK_TOKEN = 'CHECK_TOKEN';

export const LOGOUT = 'LOGOUT';

export const AIRBNB_LOGIN_START = 'AIRBNB_LOGIN_START';
export const AIRBNB_CAPTCHA_VERIFICATION_REQUESTED = 'AIRBNB_CAPTCHA_VERIFICATION_REQUESTED';
export const AIRBNB_CAPTCHA_VERIFICATION_WAITING = 'AIRBNB_CAPTCHA_VERIFICATION_WAITING';
export const AIRBNB_CAPTCHA_VERIFICATION_SUCCESS = 'AIRBNB_CAPTCHA_VERIFICATION_SUCCESS';
export const AIRBNB_EMAIL_VERIFICAION_START = 'AIRBNB_EMAIL_VERIFICAION_START';
export const AIRBNB_EMAIL_VERIFICAION_SUCCESS = 'AIRBNB_EMAIL_VERIFICAION_SUCCESS';
export const AIRBNB_LOGIN_SUCCESS = 'AIRBNB_LOGIN_SUCCESS';
export const AIRBNB_LOGIN_ERROR = 'AIRBNB_LOGIN_ERROR';

export interface AuthErrorState {
  error: boolean;
  reason: string;
}

export interface AuthSuccessState {
  error: boolean;
}
